import { render, staticRenderFns } from "./SectionCategoryList.vue?vue&type=template&id=5b9305f2"
import script from "./SectionCategoryList.vue?vue&type=script&lang=js"
export * from "./SectionCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports